import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { useReprocessModal } from "./use-reprocess-modal";
import { ReprocessModeSelection } from "./reprocess-mode-selection";
import { SyncProcessingFlow } from "./sync-processing-flow";
import { AsyncConfirmationFlow } from "./async-confirmation-flow";
import { ReprocessMode } from "./types";
import { useEffect } from "react";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { useReprocess } from "@/context/reprocess-context";
import { useParams } from "react-router-dom";

const MODE_COMPONENTS: Record<ReprocessMode, React.ComponentType<any>> = {
  selection: ReprocessModeSelection,
  'sync-loading': SyncProcessingFlow,
  'async-confirm': AsyncConfirmationFlow,
  'async-info': AsyncConfirmationFlow,
};

const RELOAD_DELAY = 500;

export default function ReprocessConciliation() {
  const { handleModal } = useDialogModal();
  const { state, actions } = useReprocessModal();
  const { startTracking } = useReprocess();
  const params = useParams();

  const reloadPage = () => {
    setTimeout(() => window.location.reload(), RELOAD_DELAY);
  };

  const handleSyncComplete = () => {
    reloadPage();
    actions.closeModal();
  };
  const handleAsyncCancel = () => actions.openModal();

  const isLoading = state.mode === 'sync-loading';
  const isSyncMode = state.mode === 'sync-loading';

  const ModeComponent = state.mode ? MODE_COMPONENTS[state.mode] : null;
  const transactionId = params?.id_transaction || "";

  const getModalTitle = () => {
    if (state.mode === 'selection') {
      return "Reprocessar Conciliação";
    }
    if (state.mode === 'sync-loading') {
      return "Reprocessando Conciliacão";
    }
    if (state.mode === 'async-confirm') {
      return "Confirmar Processamento em Segundo Plano";
    }
    if (state.mode === 'async-info') {
      return "Reprocessamento Iniciado";
    }
    return null;
  };

  const getComponentProps = () => {
    if (state.mode === 'selection')
      return {
        onSelectSync: actions.selectSync,
        onSelectAsync: actions.selectAsync,
        onCancel: actions.closeModal,
        isLoading,
      };

    if (state.mode === 'sync-loading')
      return { onComplete: handleSyncComplete, transactionId };

    if (state.mode === 'async-confirm' || state.mode === 'async-info')
      return {
        step: state.mode === 'async-confirm' ? 'confirm' : 'info',
        onConfirm: actions.showAsyncInfo,
        onCancel: handleAsyncCancel,
        onClose: actions.closeModal,
        transactionId,
        onJobCreated: startTracking,
      };

    return {};
  };

  useEffect(() => {
    if (state.isOpen && ModeComponent) {
      handleModal({
        isOpen: true,
        title: getModalTitle(),
        element: <ModeComponent {...getComponentProps()} />,
        onClose: !isSyncMode ? actions.closeModal : undefined,
      });
    } else if (!state.isOpen) {
      handleModal({
        isOpen: false,
        element: null,
      });
    }
  }, [state.isOpen, state.mode, isLoading]);

  return (
    <Button
      onClick={actions.openModal}
      disabled={isLoading}
      className="!rounded border !border-none disabled:cursor-not-allowed disabled:opacity-50 flex items-center gap-2"
    >
      <RefreshCw className="h-4 w-4" />
      Reprocessar Conciliação
    </Button>
  );
}
